module.exports = __webpack_public_path__ + "media/wantSome.de162570.mp3";